import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, signal } from '@angular/core';
import { MusicDataService } from '../music-data.service';
import { DeezerLinkComponent } from '../shared/deezer-link.component';
import { PlayerModeToggleComponent } from '../shared/player-mode-toggle.component';
import { TrackPlayerComponent } from '../shared/track-player.component';
import { Router, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatIcon } from '@angular/material/icon';
import { MatList } from '@angular/material/list';
import { MatCard, MatCardContent } from '@angular/material/card';
import { FlexModule } from '@ngbracket/ngx-layout/flex';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';
import { MatButtonModule } from '@angular/material/button';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-favourites',
  templateUrl: './favourites.component.html',
  styleUrls: ['./favourites.component.css'],
  imports: [MatIcon, MatList, MatCard, MatCardContent, RouterLink, FlexModule, ExtendedModule, MatButtonModule, DeezerLinkComponent, PlayerModeToggleComponent, TrackPlayerComponent]
})
export class FavouritesComponent implements OnInit, OnDestroy {
  public favourites = signal<any[]>([]);
  public page = signal(1);
  public totalItems = signal(0);
  public pageSize: number = 28;
  public expandedTrackIds = signal<ReadonlySet<string>>(new Set());

  private favSub: Subscription | null = null;
  private removeSub: Subscription | null = null;

  protected Math = Math;

  constructor(
    private router: Router,
    private data: MusicDataService,
  ) { }

  toggleExpand(trackId: string): void {
    this.expandedTrackIds.update(ids => {
      const next = new Set(ids);
      if (!next.delete(trackId)) {
        next.add(trackId);
      }
      return next;
    });
  }

  isExpanded(trackId: string): boolean {
    return this.expandedTrackIds().has(trackId);
  }

  storeFav(page: number = 1): void {
    this.page.set(page);
    this.favSub = this.data.getFavourites(this.page(), this.pageSize).subscribe({
      next: (data) => {
        console.log('Favourites response:', data);
        if (data && data.tracks) {
          console.log('Setting favourites array with', data.tracks.length, 'tracks');
          console.log('First track:', data.tracks[0]);
          this.favourites.set(data.tracks);
          this.totalItems.set(data.total);
        } else {
          console.log('No tracks in response');
        }
      },
      error: (error) => {
        console.error('Error fetching favourites:', error);
      }
    });
  }

  changePage(delta: number): void {
    const nextPage = this.page() + delta;
    const totalPages = Math.ceil(this.totalItems() / this.pageSize);
    if (nextPage >= 1 && (nextPage <= totalPages || totalPages === 0)) {
      this.storeFav(nextPage);
    }
  }

  ngOnInit(): void {
    this.storeFav(1);
  }

  removeFromFavourites(id: string): void {
    this.removeSub = this.data.removeFromFavourites(id).subscribe({
      next: () => {
        // After removal, re-fetch the current page to update view
        this.storeFav(this.page());
      },
      error: (error) => {
        console.error('Error removing favourite:', error);
      }
    });
  }

  ngOnDestroy(): void {
    this.favSub?.unsubscribe();
    this.removeSub?.unsubscribe();
  }
}
